import de from "element-ui/src/locale/lang/de";
import fa from "element-ui/src/locale/lang/fa";

let tool = function () {
  this.v = '0.1.1'
}
let me = tool.prototype
/**
 * 深拷贝
 * @param obj 需要被深拷贝的对象
 * @param deep 是否采用深度模式 采用深度模式请自行解决对象互相引用问题
 * @returns {*[]}
 */
me.deepCopy = function (obj, deep) {
  if (obj instanceof Array) {
    return [...obj]
  } else if (obj instanceof Object) {
    if (deep) {
      let obj2 = {}
      for (let key in obj) {
        let child = obj[key]
        if (child instanceof Array) {
          obj2[key] = this.deepCopy(obj[key], deep)
        } else if (child instanceof Object) {
          obj2[key] = this.deepCopy(obj[key], deep)
        } else {
          obj2[key] = obj[key]
        }
      }
      return obj2
    } else {
      return { ...obj }
    }
  } else {
    return obj
  }
}

/**
 * 合并对象或着数组
 * @param obj1 第一个对象
 * @param obj2 第二个对象
 */
me.merge = function (obj1, obj2) {
  if (obj1 instanceof Array) {
    return [...obj1, ...obj2]
  } else if (obj1 instanceof Object){
    let objResult = this.deepCopy(obj1, true)
    let objTemp = this.deepCopy(obj2, true)
    for (let key in objTemp) {
      objResult[key] = objTemp[key]
    }
    return objResult
  } else {
    throw '无法合并非引用了类型对象'
  }
}
/**
 * 判断字符串是空或者无长度字符串
 * @param str
 */
me.isNullOrEmpty = function (str){
  if (str === null){
    return true
  }
  str = str.trim()
  if (str.length === 0){
    return true
  }
  return false
}
export default new tool()
